import React                from 'react'
import PropTypes            from 'utils/prop-types'
import cx                   from 'utils/classnames'
import {
    FormControlContext
}                           from 'entrada-ui/FormControl'
import {
    useContext,
    getContextState
}                           from 'entrada-ui/utils'
import InputLabel           from 'entrada-ui/InputLabel'
import FormControl          from 'entrada-ui/FormControl'
import FormHelpText         from 'entrada-ui/FormHelpText'
import SelectInput          from './SelectInput'
import styles               from './styles.module.scss'

const Select = React.memo((props) => {
    const {
        id,
        classes = {},
        className: classNameRoot,
        label,
        fullWidth,
        touched,
        error,
        disabled,
        required,
        formControlRef,
        InputLabelProps,
        SelectInputPropsProp = React.useMemo(() => ({
            className: '',
            classes: {}
        })),
        helperText,
        onMetaChange,
        ...restProps
    } = props

    const InputLabelId = id ? `${id}-input-label` : undefined
    const FormHelpTextId = id && (helperText || (touched && error)) ? `${id}-help-text` : undefined

    const {
        className: SelectInputClassName,
        classes: SelectInputClasses,
        ...SelectInputProps
    } = SelectInputPropsProp

    return (
        <FormControl
            ref={formControlRef}
            className={cx(
                styles.root,
                classes.root,
                classNameRoot
            )}
            onMetaChange={onMetaChange}
            fullWidth={fullWidth}
            touched={touched}
            error={error}
            disabled={disabled}
            required={required}
        >
            <FormControl.InputArea>
                <FormControl.Label
                    label={label}
                    id={InputLabelId}
                    aria-describedby={FormHelpTextId}
                    {...InputLabelProps}
                />

                <SelectInput
                    aria-labelledby={InputLabelId}
                    aria-describedby={FormHelpTextId}
                    touched={touched}
                    error={error}
                    {...restProps}
                    {...SelectInputProps}
                    className={SelectInputClassName}
                    classes={{
                        ...SelectInputClasses,
                        filled: styles['select-filled']
                    }}
                />
            </FormControl.InputArea>

            <FormHelpText id={FormHelpTextId}>
                {helperText}
            </FormHelpText>
        </FormControl>
    )
})

Select.propTypes = {
    id: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,

    name: PropTypes.string,
    value: PropTypes.oneOfType([
        () => null,
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ]),
    onChange: PropTypes.func,

    required: PropTypes.bool,
    disabled: PropTypes.bool,
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
        () => undefined,
        PropTypes.bool,
        PropTypes.string,
    ]),

    loading: PropTypes.bool,
    clearable: PropTypes.bool,
    rtl: PropTypes.bool,
    searchable: PropTypes.bool,

    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ),

    InputLabelProps: PropTypes.object,
    SelectInputProps: PropTypes.object,
    // FormHelpTextProps: PropTypes.object,

    helperText: PropTypes.node,

    /**
     * This is useful if we want to render the field error outside of the component.
     */
    onMetaChange: PropTypes.func,

    children: PropTypes.node,
}

export default Select
